import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Badge } from '../components/ui/badge';
import { Target } from 'lucide-react';

export function FrameworkSelector({ frameworks, selectedFramework, onSelect, disabled }) {
  const safeFrameworks = frameworks || [];
  const selected = safeFrameworks.find(f => f.id === selectedFramework);

  return (
    <div className="space-y-3" data-testid="framework-selector">
      <div className="flex items-center gap-2">
        <Target className="w-4 h-4 text-brand-primary" />
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">
          Framework
        </span>
      </div>
      
      <Select 
        value={selectedFramework} 
        onValueChange={onSelect}
        disabled={disabled}
      >
        <SelectTrigger 
          className="w-full rounded-md bg-white" 
          data-testid="framework-select-trigger"
        >
          <SelectValue placeholder="Select a framework" />
        </SelectTrigger>
        <SelectContent>
          {safeFrameworks.map(framework => (
            <SelectItem 
              key={framework.id} 
              value={framework.id}
              data-testid={`framework-option-${framework.id}`}
            >
              <div className="flex items-center gap-2">
                <span className="font-medium">{framework.name}</span>
                {framework.is_default && (
                  <Badge variant="outline" className="text-xs bg-brand-muted text-brand-primary border-brand-accent">
                    Default
                  </Badge>
                )}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {selected && (
        <div className="bg-zinc-50 border border-zinc-200 rounded-md p-3">
          <p className="text-sm text-zinc-600 mb-2">{selected.description}</p>
          <div className="flex flex-wrap gap-1">
            {selected.categories?.map((cat, i) => (
              <Badge 
                key={i} 
                variant="outline" 
                className="text-xs bg-white"
              >
                {cat}
              </Badge>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
